import { Box, Typography, Button, Container } from '@mui/material';
import { colors } from './theme';

function HeroSection() {
  return (
    <Box sx={{ 
      bgcolor: 'primary.main', 
      py: { xs: 6, md: 10 },
      mb: 0,
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: colors.darkPurple,
        zIndex: 1,
      }
    }}>
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
        <Box sx={{ 
          maxWidth: { xs: '100%', md: '80%' }, 
          mx: 'auto',
          color: 'white',
          textAlign: { xs: 'center', md: 'left' },
          textShadow: '0 2px 4px rgba(0,0,0,0.3)'
        }}>
          <Typography 
            variant="h1" 
            component="h1" 
            gutterBottom
            sx={{ 
              fontSize: { xs: '2.5rem', sm: '3rem', md: '3.5rem' },
              fontWeight: 800,
              lineHeight: 1.2,
              mb: 3,
              color: 'white',
            }}
          >
            Welcome to Coachivate
          </Typography>
          
          <Typography 
            variant="h4" 
            component="p" 
            gutterBottom
            sx={{ 
              fontWeight: 500,
              mb: 3,
              color: 'rgba(255, 255, 255, 0.95)',
            }}
          >
            Amplify Hope, Ignite Your Potential
          </Typography>
          
          <Typography 
            variant="body1" 
            component="p"
            sx={{ 
              maxWidth: { xs: '100%', md: '80%' },
              fontSize: '1.2rem',
              lineHeight: 1.7,
              mb: 5,
              color: 'rgba(255, 255, 255, 0.9)',
            }}
          >
            Professional coaching to help you break through limitations, reclaim your confidence, and create meaningful change.
          </Typography>
          
          {/* Buttons row */}
          <Box sx={{ 
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            flexWrap: 'wrap',
            justifyContent: { xs: 'center', md: 'flex-start' },
            gap: 2,
            mt: 4
          }}>
            <Button 
              variant="contained" 
              color="secondary"
              size="large"
              href="#book"
              sx={{ 
                minWidth: '200px',
                bgcolor: 'white',
                color: 'primary.main',
                '&:hover': {
                  bgcolor: 'rgba(255, 255, 255, 0.9)'
                }
              }}
            >
              Book a Session
            </Button>
            <Button 
              variant="outlined" 
              size="large"
              href="#services"
              sx={{ 
                minWidth: '180px',
                borderColor: 'white',
                color: 'white',
                '&:hover': {
                  bgcolor: 'rgba(255, 255, 255, 0.1)',
                  borderColor: 'white'
                }
              }}
            >
              Services
            </Button>
            <Button 
              variant="outlined" 
              size="large"
              href="#about"
              sx={{ 
                minWidth: '180px',
                borderColor: 'white',
                color: 'white',
                '&:hover': {
                  bgcolor: 'rgba(255, 255, 255, 0.1)',
                  borderColor: 'white'
                }
              }}
            >
              About Me
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default HeroSection;
